/* eslint-disable */

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

// TREATWELL
// Copied from https://gist.github.com/paulirish/1579671
// NOTE: Added the root variable to check if the window object is set

const root = typeof window === 'undefined' ? global : window;
let lastTime = 0;
const vendors = ['ms', 'moz', 'webkit', 'o'];

for (let x = 0; x < vendors.length && !root.requestAnimationFrame; ++x) {
  root.requestAnimationFrame = root[`${vendors[x]}RequestAnimationFrame`];
  root.cancelAnimationFrame =
    root[`${vendors[x]}CancelAnimationFrame`] ||
    root[`${vendors[x]}CancelRequestAnimationFrame`];
}

if (!root.requestAnimationFrame) {
  root.requestAnimationFrame = function(callback) {
    const currTime = new Date().getTime();
    const timeToCall = Math.max(0, 16 - (currTime - lastTime));
    const id = root.setTimeout(() => {
      callback(currTime + timeToCall);
    }, timeToCall);

    lastTime = currTime + timeToCall;
    return id;
  };
}

if (!root.cancelAnimationFrame) {
  root.cancelAnimationFrame = function(id) {
    clearTimeout(id);
  };
}

/* eslint-enable */
